import LazySelect from './LazySelect';

export default LazySelect;
